import React from 'react';
import '../styles/Uttarakhand.css';
import logo from "../assets/logo3.webp";
import { Link, useLocation } from "react-router-dom";
import uttarakhandData from '../data/uttarakhand.json';
import uttarakhandBanner from '../assets/uttarakhand.png';

const imageMap = {
  '../assets/nainital.png': require('../assets/nainital.png'),
  '../assets/mussoorie.png': require('../assets/mussoorie.png'),
  '../assets/rishikesh.png': require('../assets/rishikesh.png'),
  '../assets/haridwar.png': require('../assets/haridwar.png'),
  '../assets/auli.png': require('../assets/auli.png'),
  '../assets/almora.png': require('../assets/almora.png'),
  '../assets/jimcorbett.png': require('../assets/jimcorbett.png'),
  '../assets/bhimtal.png': require('../assets/bhimtal.png'),
  '../assets/valleyofflowers.png': require('../assets/valleyofflowers.png'),
  '../assets/chopta.png': require('../assets/chopta.png'),
  '../assets/kedarnath.png': require('../assets/kedarnath.png'),
  '../assets/badrinath.png': require('../assets/badrinath.png'),
'../assets/yamunotri.png': require('../assets/yamunotri.png'),
'../assets/gangotri.png': require('../assets/gangotri.png'),
'../assets/tungnath.png': require('../assets/tungnath.png'),
'../assets/neelkanth.png': require('../assets/neelkanth.png'),
'../assets/mansadevi.png': require('../assets/mansadevi.png'),
'../assets/dharadevi.png': require('../assets/dharadevi.png'),
'../assets/jageshwar.png': require('../assets/jageshwar.png'),
'../assets/rafting.png': require('../assets/rafting.png'),
'../assets/kedarkantha.png': require('../assets/kedarkantha.png'),
'../assets/skiing.jpg': require('../assets/skiing.jpg'),
'../assets/camping.png': require('../assets/camping.png'),
'../assets/bungee.png': require('../assets/bungee.png'),
'../assets/paragliding.png': require('../assets/paragliding.png'),
'../assets/rockclimbing.png': require('../assets/rockclimbing.png'),
'../assets/ziplining.png': require('../assets/ziplining.png'),
'../assets/hotair.png': require('../assets/hotair.png'),
'../assets/nainiretreat.png': require('../assets/nainiretreat.png'),
'../assets/marriot.png': require('../assets/marriot.png'),
'../assets/aloha.png': require('../assets/aloha.png'),
'../assets/solluna.png': require('../assets/solluna.png'),
'../assets/bluepine.png': require('../assets/bluepine.png'),
'../assets/chevron.png': require('../assets/chevron.png'),
'../assets/sunita.png': require('../assets/sunita.png'),
'../assets/tattva.png': require('../assets/tattva.png'),
'../assets/sterling.png': require('../assets/sterling.png'),
'../assets/zostelrishikesh.png': require('../assets/zostelrishikesh.png')
    
};

const Uttarakhand = () => {
     const location = useLocation();
  return (
    <>
     <header className="contact-header over-banner">
        <div className="contact-logo">
          <img src={logo} alt="Tourly Logo" />
        </div>
        <nav className="contact-nav">
          <Link to="/">Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="contact-dropdown">
        <a href="#" className={`contact-dropbtn ${location.pathname === '/uttarakhand' ? 'active-link' : ''}`}>Destinations</a> 

<div className="contact-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
                              <Link to="/abu">Abu Dhabi</Link>
                <Link to="/dubai">Dubai</Link>
            </div>
          </div>
            <Link to="/hotels">Hotels</Link>
        <Link to="/contact-us" className={location.pathname === '/contact-us' ? 'active-link' : ''}>Contact Us</Link>
          
        </nav>
  <Link to="/booknow">
        <button className="contact-book-btn">Book Now</button>
                    </Link>      </header>
    <div className="uttarakhand-page">
      <div className="uttarakhand-hero">
        <div className="uttarakhand-hero-overlay">
          <h1>Explore Uttarakhand</h1>
          <p>Devbhoomi, Himalayas, Adventure – Your Spiritual Mountain Retreat</p>
        </div>
        <img src={uttarakhandBanner} alt="uttarakhand Banner" className="uttarakhand-hero-img" />
      </div>

      <section className="uttarakhand-info">
        <h2>Welcome to Uttarakhand</h2>
        <p>
          Uttarakhand, often called "Devbhoomi" (Land of Gods), is a spiritual and adventurous haven nestled in the mighty Himalayas. It's renowned for its sacred pilgrimage sites, breathtaking mountain vistas, thrilling adventure sports, and serene yoga and wellness centers. Whether you seek spiritual solace, adrenaline-pumping activities, or a peaceful escape into nature, Uttarakhand has it all.
        </p>
      </section>

      {Object.entries(uttarakhandData).map(([sectionTitle, items]) => (
        <section className="uttarakhand-section" key={sectionTitle}>
          <h2>{formatTitle(sectionTitle)}</h2>
          <div className="uttarakhand-cards-container">
            {items.map((item, index) => (
              <div className="uttarakhand-card" key={index}>
             < img
                  src={imageMap[item.image] || item.image}
                  alt={item.name}
                />
                <h3>{item.name}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
    </>
  );
};

const formatTitle = (key) => {
  switch (key) {
    case 'Beaches': return 'Beaches';
    case 'Clubs': return 'Clubs';
    case 'Cafes': return 'Cafes';
    case 'Hotels': return 'Hotels & Resorts';
    case 'Forts': return 'Forts';
    default: return key;
  }
};

export default Uttarakhand;
